module.exports = __webpack_public_path__ + "static/media/cloud-service.7ab5d082.svg";